import { Module } from "wrapper6";
import MobileSlider from "./_mobile-slider";
import GA4TrackingHandler from './_ga4-tracking-handler'
/* global jQuery,main_theme_objects */
var $ = jQuery;

export default class LoadMoreItems extends Module {

	ready() {

		let LMI = this;

		$('.mtt-courses .toggle').on('click',function(){
			let toggle = $(this);
			let filter_type = toggle.data('toggle');
			let button = toggle.closest('.mtt-courses').find('button.load_more_items');
			if(button.length > 0){
				LMI.updateFilterType(button,filter_type);
			}
		});

		$('.load_more_items').on('click', function(e) {
			e.preventDefault();

			let button = $(this);
			let current_page = LMI.getCurrentPage(button);
			let post_type = LMI.getPostType(button);
			let highlighted_courses = button.attr('data-highlighted_courses');

			if(current_page === null || post_type === null){
				console.warn('Could not fetch new items. Either current_page or post_type are invalid.',button); // TODO: Eventually remove warning
				return;
			}
			// Object for the request data
			let data = {
				action: 'load_more_items',
				post_type: post_type,
				paged: current_page + 1,
				exclude: (highlighted_courses != '') ? highlighted_courses : []
			};

			let term_id = LMI.getTermId(button);
			if(term_id !== null){
				data.term_id = term_id;
			}

			let filter_type = LMI.getFilterType(button);
			if(filter_type !== null){
				data.filter_type = filter_type;
			}

			LMI.showLoader(button);

			$.ajax({
				method: 'POST',
				url: main_theme_objects.ajax_url,
				data: data,
			}).success(function(response,status,xhr) {
				if(xhr.status === 200){
					LMI.updateCurrentPage(button,data.paged);
					LMI.updateItemsList(button,response.items);
					if (Number(response.max_pages) === Number(data.paged)) {
						LMI.noMoreItems(button)
					}

          let ga4TrackingElement = button.closest('[data-ga4-tracking--vil]')
          let g4aTrackingData = JSON.parse(ga4TrackingElement.attr('data-ga4-tracking--data'))

          let itemListId = g4aTrackingData.post_type + '__view-list-items'
          let itemListName = g4aTrackingData.title

          if (ga4TrackingElement.find('.toggle-container').length > 0) {
            let typeElement = ga4TrackingElement.find('.toggle-container .toggle.active')
            let typeSlug = typeElement.attr('data-toggle')
            let typeTitle = typeElement.text()

            itemListId = typeElement.length > 0 ? g4aTrackingData.post_type + '--' + typeSlug + '__view-list-items' : itemListId
            itemListName = typeElement.length > 0 ? g4aTrackingData.title + ' - ' + typeTitle : itemListName
          }

          GA4TrackingHandler.addViewItemListFromItems(
            response.ga4_items,
            {
              itemListId: itemListId,
              item_list_name: itemListName,
            },
            (Number(data.paged) - 1) * response.ga4_items.length
          )
				}else{
					console.error('Could not fetch new items',xhr);
				}
				LMI.hideLoader(button);
			});
		});
	}

	getSection(button){
		let section = button.closest('section.mtt-courses');
		if(section.length !== 1){
			section = null;
		}
		return section;
	}
	getLoader(button){
		let section = this.getSection(button);
		if(section === null) return null;
		let loader = section.find('.loader-overlay');
		if(loader.length < 1){
			loader = null;
		}
		return loader;
	}
	showLoader(button){
		let loader = this.getLoader(button);
		if(loader !== null){
			loader.addClass('show');
		}
	}
	hideLoader(button){
		let loader = this.getLoader(button);
		if(loader !== null){
			loader.removeClass('show');
		}
	}

	getCurrentPage(button){
		let current_page = null;
		let current_page_val = button.data('current_page');
		let current_page_int = parseInt(current_page_val);
		// Making sure current_page is set and a valid int
		if(current_page_int === current_page_val){
			current_page = current_page_int;
		}
		return current_page;
	}
	getPostType(button){
		let post_type = button.data('post_type');
		let validTypes = ['education','course', 'e-learning'];
		if(validTypes.indexOf(post_type) < 0){
			post_type = null;
		}
		return post_type;
	}
	getTermId(button){
		let term_id = button.data('term_id');
		if(typeof term_id === "undefined" || term_id === ''){
			term_id = null;
		}
		return term_id;
	}
	getFilterType(button){
		let filter_type = button.data('filter_type');
		if(filter_type !== 'newest' && filter_type !== 'popular'&& filter_type !== 'featured'){
			filter_type = 'newest';
		}
		return filter_type;
	}
	updateFilterType(button,filter_type){
		if(filter_type !== 'newest' && filter_type !== 'popular'&& filter_type !== 'featured') return;
		button.data('filter_type',filter_type);
		this.updateCurrentPage(button,1); // Reset
	}
	updateCurrentPage(button,current_page){
		button.data('current_page',current_page);
	}
	updateItemsList(button,items){
		let items_length = items.length;
		if(items_length < 1){
			this.noMoreItems(button);
			return;
		}

		let section = this.getSection(button);
		if(section === null){
			console.error('LoadMoreItems button has no page_section');
		}

		let wrapper = section.find('.courses-wrapper');
		if(wrapper.length !== 1){
			console.error('LoadMoreItems button has no courses-wrapper');
		}

		for (var i = 0; i < items_length; i++){
			wrapper.append(items[i]);
		}

		window.glide_remount();
	}
	noMoreItems(button){
		button.hide();
		// alert('Der er ikke flere elementer at vise');
	}
}